/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.DATE = function () {

    this.resourceKey = 'Survey.Sidebar.Date';
    this.jsonType = 'DATE';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);
};